import { observer } from "mobx-react";
import React from "react";

import { useMainStore } from "@/contexts/Store";
import TaskDetail from "@/features/tasks/components/TaskDetail";

import DashboardMenu from "./dashboard/sidebar/DashboardMenu";
import OverviewMenu from "./overviewMenu/OverviewMenu";

type MainContentProps = {
  children: React.ReactNode;
  hideOverviewMenu?: boolean;
};

function MainContent({ children, hideOverviewMenu = false }: MainContentProps) {
  const mainStore = useMainStore();
  const showTaskDetailMenu = mainStore.taskDetail.isOpen;

  return (
    <div className="dashboard-wrap">
      <DashboardMenu />
      <div className="dashboard-wrap__main">{children}</div>
      {!hideOverviewMenu && <OverviewMenu />}
      {showTaskDetailMenu && <TaskDetail />}
    </div>
  );
}

export default observer(MainContent);
